import React from "react";
import { AddButton, Aside, ButtonProps, useDisclosure } from "sprint-common-web";

import { DistributorsDataProvider } from "../../data/lookup-data-providers/DistributorsDataProvider";
import { ContentVersionDetails, CreateContentVersionParams } from "./ContentVersion";
import { CreateContentVersionForm } from "./CreateContentVersionForm";

export type CreateVersionButtonProps = Pick<ButtonProps, "styles" | "disabled"> & {
    isLabeled?: boolean;
    onClick?(): void;
    onContentVersionCreated?(newVersion: ContentVersionDetails): void;
    content: CreateContentVersionParams;
};

export const CreateContentVersionButton = (props: CreateVersionButtonProps): JSX.Element => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const closeAside = () => {
        onClose();
    };

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.currentTarget.blur();
        onOpen();
    };

    const handleFormSubmit = (newVersion: ContentVersionDetails) => {
        props.onContentVersionCreated?.(newVersion);
        closeAside();
    };

    return (
        <>
            <AddButton
                onClick={handleButtonClick}
                isLabeled={props.isLabeled}
                label="Add"
                disabled={props.disabled}
                styles={props.styles}
            />
            <Aside isOpen={isOpen} type="form" headerText="Add Content Version" onDismiss={closeAside}>
                <DistributorsDataProvider>
                    <CreateContentVersionForm
                        onCancel={closeAside}
                        onSubmit={handleFormSubmit}
                        content={props.content}
                    />
                </DistributorsDataProvider>
            </Aside>
        </>
    );
};
